import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActiveinitialInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 18,
			stroke: "#BCA4FF",
			strokeDasharray: "7 7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 14,
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1057 18.2473C19.0391 18.2407 18.9591 18.2407 18.8857 18.2473C17.2991 18.194 16.0391 16.894 16.0391 15.294C16.0391 13.6607 17.3591 12.334 18.9991 12.334C20.6324 12.334 21.9591 13.6607 21.9591 15.294C21.9524 16.894 20.6924 18.194 19.1057 18.2473Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7725 20.706C14.1592 21.786 14.1592 23.546 15.7725 24.6193C17.6058 25.846 20.6125 25.846 22.4458 24.6193C24.0592 23.5393 24.0592 21.7793 22.4458 20.706C20.6192 19.486 17.6125 19.486 15.7725 20.706Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActiveinitialInfo;
